import { render, staticRenderFns } from "./compWalletReport.vue?vue&type=template&id=6ae72a1c"
import script from "./compWalletReport.vue?vue&type=script&lang=js"
export * from "./compWalletReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports